exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".course-content{height:calc(100% - 40px)}jdiv{display:none!important}.margin-top-70{margin-top:70px}@media only screen and (min-width:1px) and (max-width:1024px){.body-panel-content-page{padding:12px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-03e047dc","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Content/src/views/details/MaterialFileDetailsMobileApp.vue
// module id = 668
// module chunks = 1